import { FormControl, NgControl } from '@angular/forms';
import { inject, Injectable, OnInit } from '@angular/core';

@Injectable()
export class AutocompleteWrapper implements OnInit {
  protected formControl: FormControl = new FormControl(null);
  private ngControl = inject(NgControl, { optional: true, self: true });

  ngOnInit() {
    const control = this.ngControl?.control;
    if (control)
      if (control instanceof FormControl) this.formControl = control;
      else throw new Error(`Autocomplete ngControl must be a form control.`);
    return control;
  }
}
